import React, { useState } from 'react';
import { PrimaryButton } from 'components/v2/buttons';
import ChooseToolTypeDialog from './ChooseToolTypeDialog';
import { useHistory } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from 'services/api/constants';

const CreateToolButton: React.FC = () => {
  const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const router = useHistory();

  const handleToolCreated = (toolId: string) => {
    router.push(EpdLinks.editTool(toolId));
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ADMIN_TOOL] });
  };

  return (
    <>
      <PrimaryButton onClick={() => setIsDialogVisible(true)}>New tool</PrimaryButton>

      <ChooseToolTypeDialog
        visible={isDialogVisible}
        onHide={() => setIsDialogVisible(false)}
        onCreated={handleToolCreated}
      />
    </>
  );
};

export default CreateToolButton;
